export const length = (s) => s.length
export const concat = (a, b) => a + b
export const charCodeAt = (s, i) => s.charCodeAt(i >>> 0)
export const substring = (s, start, end) => {
    start >>>= 0;
    end >>>= 0;
    return s.substring(start, end);
}

export const compare = (a, b) => {
    return a === b ? 0 : a < b ? -1 : 1;
}

export const equals = (a, b) => a === b ? 1 : 0
const moduleFromCharCodeArray = new WebAssembly.Module(new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00, 0x01, 0x0b, 0x02, 0x5e,
  0x77, 0x01, 0x60, 0x02, 0x64, 0x00, 0x7f, 0x01, 0x7f, 0x03, 0x02, 0x01,
  0x01, 0x07, 0x0b, 0x01, 0x07, 0x61, 0x31, 0x36, 0x5f, 0x67, 0x65, 0x74,
  0x00, 0x00, 0x0a, 0x0b, 0x01, 0x09, 0x00, 0x20, 0x00, 0x20, 0x01, 0xfb,
  0x0d, 0x00, 0x0b, 0x00, 0x13, 0x04, 0x6e, 0x61, 0x6d, 0x65, 0x04, 0x0c,
  0x01, 0x00, 0x09, 0x61, 0x72, 0x72, 0x61, 0x79, 0x5f, 0x69, 0x31, 0x36
]));
const helpersFromCharCodeArray = new WebAssembly.Instance(moduleFromCharCodeArray).exports;

export const fromCharCodeArray = (array, start, end) => {
    start >>>= 0;
    end >>>= 0;
    let result = [];
    for (let i = start; i < end; i++) {
        result.push(String.fromCharCode(helpersFromCharCodeArray.a16_get(array, i)));
    }
    return result.join("");
}

const moduleIntoCharCode = new WebAssembly.Module(new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00, 0x01, 0x0b, 0x02, 0x5e,
  0x77, 0x01, 0x60, 0x03, 0x64, 0x00, 0x7f, 0x7f, 0x00, 0x03, 0x02, 0x01,
  0x01, 0x07, 0x0b, 0x01, 0x07, 0x61, 0x31, 0x36, 0x5f, 0x73, 0x65, 0x74,
  0x00, 0x00, 0x0a, 0x0d, 0x01, 0x0b, 0x00, 0x20, 0x00, 0x20, 0x01, 0x20,
  0x02, 0xfb, 0x0e, 0x00, 0x0b, 0x00, 0x13, 0x04, 0x6e, 0x61, 0x6d, 0x65,
  0x04, 0x0c, 0x01, 0x00, 0x09, 0x61, 0x72, 0x72, 0x61, 0x79, 0x5f, 0x69,
  0x31, 0x36
]));
const helpersIntoCharCode = new WebAssembly.Instance(moduleIntoCharCode).exports;

export const intoCharCodeArray = (s, array, start) => {
    start >>>= 0;
    for (let i = 0; i < s.length; i++) {
      helpersIntoCharCode.a16_set(array, start + i, s.charCodeAt(i));
    }
    return s.length;
}
